import ability from './ability'

export const canNavigate = (to) =>  {
    return to.matched.some((route) => {
        if (route.meta.resource) {
            return ability.can(route.meta.action || 'read', route.meta.resource);
        }
        return ability.can('visit', route.name);
    });
};

export const _ = undefined
